"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var LayoutDirections;
(function (LayoutDirections) {
    LayoutDirections["Column"] = "column";
    LayoutDirections["Row"] = "row";
})(LayoutDirections = exports.LayoutDirections || (exports.LayoutDirections = {}));
var LayoutContext = react_1.createContext(null);
exports.useLayoutContext = function () { return react_1.useContext(LayoutContext); };
exports.RootLayoutContext = react_1.createContext(null);
exports.useRootLayoutContext = function () { return react_1.useContext(exports.RootLayoutContext); };
exports.default = LayoutContext;
